import Button from "components/Button";
import Input from "components/Input";

import EyeImg from "assets/passwordEye.svg";

import { SetStateAction } from "react";
import { PasswordForm, ViewPasswordButton } from "../../styles";

type PasswordTabProps = {
  showFirstPassword: boolean;
  setOldPassword: React.Dispatch<SetStateAction<string>>;
  handleShowFirstPassword: () => void;
  showSecondPassword: boolean;
  setNewPassword: React.Dispatch<SetStateAction<string>>;
  handleShowSecondPassword: () => void;
  showThirdPassword: boolean;
  handleShowThirdPassword: () => void;
  setVerifyPassword: React.Dispatch<SetStateAction<string>>;
  changePasswordSubmit: (event: React.SyntheticEvent) => void;
};

export default function PasswordTab({
  showFirstPassword,
  setOldPassword,
  handleShowFirstPassword,
  showSecondPassword,
  setNewPassword,
  handleShowSecondPassword,
  showThirdPassword,
  handleShowThirdPassword,
  setVerifyPassword,
  changePasswordSubmit,
}: PasswordTabProps) {
  return (
    <PasswordForm
      onSubmit={(event: React.SyntheticEvent) => changePasswordSubmit(event)}
    >
      <Input
        type={showFirstPassword ? "text" : "password"}
        id="actual password"
        name="actual password"
        label="Senha atual"
        required={false}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setOldPassword(event.target.value);
        }}
      />
      <ViewPasswordButton
        type="button"
        onClick={handleShowFirstPassword}
      >
        <img src={EyeImg} alt="eye" />
      </ViewPasswordButton>
      <Input
        type={showSecondPassword ? "text" : "password"}
        id="new password"
        name="new password"
        label="Nova senha"
        required={false}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setNewPassword(event.target.value);
        }}
      />
      <ViewPasswordButton
        type="button"
        onClick={handleShowSecondPassword}
      >
        <img src={EyeImg} alt="eye" />
      </ViewPasswordButton>
      <Input
        type={showThirdPassword ? "title" : "password"}
        id="repeated password"
        name="repeated password"
        label="Repetir senha"
        required={false}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setVerifyPassword(event.target.value);
        }}
      />
      <ViewPasswordButton
        type="button"
        onClick={handleShowThirdPassword}
      >
        <img src={EyeImg} alt="eye" />
      </ViewPasswordButton>
      <Button title="Salvar" />
    </PasswordForm>
  );
}
